import React, { useEffect, useState } from "react";
import { Form, Input, Button, Popconfirm } from "antd";
import log from "cslog";
import _, { startCase } from "lodash"
import { useSingleItem } from "../../_actions/app/items";
import PhotoButton from "../../qforms/standard_elements/PhotoButton";
import UniversalPhotoButton from "../../qforms/standard_elements/UniversalPhotoButton";
import { useUpdateItem } from "../../_actions/mutations/items";
import RenderField from "../../ai_home/RenderField";

function PresetHumanInput({ data, onChange, onGenerate, me, examples }) {
    const { input_data, prefill } = data;
    const { isSuccess, isLoading, data: dataSchema } = useSingleItem(
        "qdb_creation_schema",
        `/${input_data?.qureal_schema_id}`,
        !!input_data?.qureal_schema_id
    )
    const mutationUpdate = useUpdateItem("qdb_creation_schema", dataSchema?.id, () => { });

    const [initial_values, setInitialValues] = useState({});

    const [form] = Form.useForm();

    log.d(data, "data in PresetHumanInput")
    log.d(dataSchema, "dataSchema in PresetHumanInput")
    log.d(prefill, "prefill in PresetHumanInput")


    useEffect(() => {
        form.setFieldsValue(data?.prefill);
    }, [data?.prefill, form])



    const handleValuesChange = (changedValues, allValues) => {
        onChange && onChange(allValues);
    };

    const handleGenerate = () => {
        form.validateFields()
            .then((values) => {
                log.d("Generated values:", values);
                onGenerate && onGenerate(values); // Pass the updated values to the onGenerate callback
            })
            .catch((error) => {
                log.e("Validation failed:", error);
            });
    };



    const addAsExample = () => {
        const out_example = {};
        const temp = form.getFieldsValue();
        log.d(temp, "temp in addAsExample")
        for (const [key, value] of Object.entries(temp)) {
            if (value) {
                if (typeof value === "object" && "params" in value) {
                    out_example[key] = value?.params?.id
                } else {
                    out_example[key] = value;
                }
            }
        }
        const out = [
            ...examples,
            out_example
        ]
        log.d(out, "Out in addAsExample")
        mutationUpdate.mutate({
            examples: out
        });
    }

    if (!isSuccess) {
        return <div>Loading preset...</div>;
    }


    const schema = dataSchema?.true_schema?.schema

    return (
        <div>
            {/* <pre>{JSON.stringify(data?.prefill, null, 2)}</pre> */}
            <Form
                form={form}
                layout="vertical"
                onValuesChange={handleValuesChange}
            >
                {Object.keys(schema?.properties).map((field_key) => {
                    const field = schema?.properties[field_key]
                    return <RenderField
                        key={field_key}
                        // field={field}
                        type={field?.type || "strig"}
                        itype={field?.itype || "text"}
                        name={field_key}
                        label={startCase(field_key)}
                        field={field}
                    />
                })}

                {me?.irole === "reviewer" && <Popconfirm
                    title="Add as Example"
                    description="Are you sure want to add this as example?"
                    onConfirm={() => {
                        addAsExample();
                    }}
                    // onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button variant="dashed" loading={mutationUpdate.isLoading}>Add as example</Button>
                </Popconfirm>}
            </Form>
        </div>
    );
}

export default PresetHumanInput;
